export enum AuthenticateChannel {
  Shopee = 1,
  Google = 2,
  Facebook = 3,
  Apple = 4,
}

export enum PostProcessSignal {
  Continue = 'continue',
  Restart = 'restart',
  Stop = 'stop',
}

export type PostServiceAction<E extends string, P = {}, R = {}> = {
  type: E;
  payload: P;
  callback?: (params: R) => void | Promise<void>;
};

export type ThirdPartyAuthenticatePostContext<T = {}> = {
  state: {
    channel: AuthenticateChannel;
    payload: T;
  };
  emitAction: <Action extends PostServiceAction<any, any, any>>(
    action: Action
  ) => void;
};

export type ExecuteStatistics = {
  restartCount: number;
};

export interface ThirdPartyAuthenticatePostProcessor<
  T extends ThirdPartyAuthenticatePostContext = ThirdPartyAuthenticatePostContext
> {
  canSupport(context: T): Promise<boolean>;
  setNext: (
    next: ThirdPartyAuthenticatePostProcessor<any>
  ) => ThirdPartyAuthenticatePostProcessor<any>;
  process: (
    context: T,
    statistics: Readonly<ExecuteStatistics>
  ) => Promise<{
    signal: PostProcessSignal;
    context: T;
  }>;
  getNext: () => ThirdPartyAuthenticatePostProcessor | null;
}

export interface ThirdPartyAuthenticatePostService<
  T extends ThirdPartyAuthenticatePostContext = ThirdPartyAuthenticatePostContext
> {
  execute: (contextState: T['state']) => Promise<void>;
}
